/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class CurrencyGrid extends SiteEntityGrid<CurrencyRow, any> {
        protected getColumnsKey() { return 'Data.Currency'; }
        protected getDialogType() { return CurrencyDialog; }
        protected getIdProperty() { return CurrencyRow.idProperty; }
        protected getLocalTextPrefix() { return CurrencyRow.localTextPrefix; }
        protected getService() { return CurrencyService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}